import React from 'react';
import { motion } from 'framer-motion';
import { T } from '../../lib/tokens';

const colors = {
  active: T.green,
  working: T.amber,
  idle: T.textLight,
};

export const StatusDot = ({ status }) => (
  <motion.span
    animate={status === 'working' ? {
      scale: [1, 0.85, 1],
      opacity: [1, 0.6, 1],
    } : status === 'active' ? {
      scale: [1, 0.9, 1],
      opacity: [1, 0.7, 1],
    } : {}}
    transition={status === 'working' ? {
      duration: 2, repeat: Infinity, ease: 'easeInOut',
    } : status === 'active' ? {
      duration: 3, repeat: Infinity, ease: 'easeInOut',
    } : {}}
    style={{
      display: 'inline-block',
      width: 7, height: 7,
      borderRadius: '50%',
      background: colors[status] || T.textLight,
      flexShrink: 0,
    }}
  />
);
